import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../../../api/auth';
import { PageMeta } from '../shared/PageMeta';

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const token = searchParams.get('token') || '';

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <PageMeta title="Verify Email" description="Verify your email address" path="/marketplace/verify-email" />
      {status === 'loading' && (
        <div className="flex items-center justify-center min-h-[200px]">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-spi-green border-t-transparent" />
        </div>
      )}
      {status === 'success' && (
        <>
          <h2 className="text-2xl mb-4">Email Verified!</h2>
          <p className="text-spi-slate mb-6">Your email has been verified. Your account is now pending admin approval.</p>
          <Link to="/marketplace/login" className="btn btn-primary">Go to Login</Link>
        </>
      )}
      {status === 'error' && (
        <>
          <h2 className="text-2xl mb-4">Verification Failed</h2>
          <p className="text-spi-slate mb-6">This verification link is invalid or has already been used.</p>
          <Link to="/marketplace/login" className="btn btn-primary">Go to Login</Link>
        </>
      )}
    </div>
  );
}
